import UserForm from '../components/UserForm';
import {graphql, compose} from 'react-apollo';
import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';
import {AllClientsAndEmployeesQuery, AllClientsAndEmployeesQueryConfig} from '../qql-shared/queries';

export default compose(
  graphql(SaveUserMutation, SaveUserMutationConfig),
  graphql(AllClientsAndEmployeesQuery, AllClientsAndEmployeesQueryConfig)
)(UserForm);



// WEBPACK FOOTER //
// ./src/containers/UserNew.js